import { Reveal } from "@/components/Reveal";

const HITOS = [
  { anio: "1966", texto: "Fundación por Rodolfo Santana Lepe" },
  { anio: "1986", texto: "Rodolfo Alfonso Santana López, hijo, toma la dirección" },
  { anio: "2016", texto: "Nace Seguclick, la misma confianza ahora a un clic" },
];

export const Historia = () => (
  <section id="nosotros" data-testid="historia-section" className="bg-[#EDF2F8] py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-20">
        <Reveal className="mx-auto w-full max-w-md lg:mx-0">
          <figure className="-rotate-2 rounded-2xl bg-[#fdf6e3] p-3 shadow-[0_24px_60px_-16px_rgba(12,95,138,0.35)] transition-transform duration-500 hover:rotate-0">
            <div className="relative overflow-hidden rounded-xl border border-[#e3d3a8]">
              <img
                src="/assets/fundador.jpg"
                alt="Rodolfo Santana Lepe, fundador de Seguclick, retrato de 1966"
                loading="lazy"
                data-testid="fundador-foto"
                className="aspect-[4/5] w-full object-cover sepia-[0.2]"
              />
              <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#6b5518]/15 via-transparent to-transparent" />
            </div>
            <figcaption className="py-4 text-center font-editorial text-base text-[#6b5518] sm:text-lg">
              Rodolfo Santana Lepe, fundador · 1966
            </figcaption>
          </figure>
        </Reveal>

        <div>
          <Reveal>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.25em] text-[#1BA8E0]">
              Nuestra historia
            </p>
            <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-[#0C5F8A] sm:text-3xl lg:text-4xl">
              Una tradición que se hereda
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-6 text-base leading-relaxed text-[#2E3338]/80 sm:text-lg">
              Hace más de 60 años, Rodolfo Santana Lepe fundó este negocio con una idea sencilla: que cada
              familia tuviera a alguien de confianza cuando más lo necesitara. No vendía pólizas; daba la
              cara por sus clientes.
            </p>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-5 text-base leading-relaxed text-[#2E3338]/80 sm:text-lg">
              Desde hace más de 40 años, Rodolfo Alfonso Santana López, su hijo, lleva ese legado. Lo hizo
              crecer, sumó a las aseguradoras más sólidas del país y lo trajo a la era digital con Seguclick,
              sin perder lo que nos hace distintos: el trato personal.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="mt-5 text-base leading-relaxed text-[#2E3338]/80 sm:text-lg">
              Hoy seguimos atendiendo a los hijos y nietos de quienes confiaron en nosotros desde el principio.
            </p>
          </Reveal>
        </div>
      </div>

      <Reveal delay={0.1} className="mt-20">
        <div className="relative">
          <div className="absolute left-6 top-0 h-full w-0.5 bg-[#1BA8E0]/25 sm:left-0 sm:top-6 sm:h-0.5 sm:w-full" aria-hidden="true" />
          <ol className="grid gap-10 sm:grid-cols-3 sm:gap-6">
            {HITOS.map((hito, i) => (
              <li key={hito.anio} data-testid={`timeline-${hito.anio}`} className="relative pl-16 sm:pl-0 sm:pt-16">
                <span
                  className={`absolute left-0 top-0 flex h-12 w-12 items-center justify-center rounded-full font-display text-sm font-bold text-white shadow-lg sm:left-0 ${
                    i === HITOS.length - 1 ? "bg-[#F5B21B] text-[#0C5F8A]" : "bg-[#1BA8E0]"
                  }`}
                >
                  {hito.anio}
                </span>
                <p className="text-sm leading-relaxed text-[#2E3338]/85 sm:text-base">{hito.texto}</p>
              </li>
            ))}
          </ol>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="mt-14 text-center">
        <p className="mx-auto max-w-3xl text-sm leading-relaxed text-[#2E3338]/70 sm:text-base">
          Desde hace más de 40 años, mantenemos alianzas con las mejores aseguradoras de México: AXA, Mapfre,
          GNP, Seguros Latino y otras más.
        </p>
      </Reveal>
    </div>
  </section>
);
